import { CCTM, CCTM_demo, CCTM_item, CCTM_items, CCTM_link, CCTM_nav, CCTM_route, CCTM_subnav, NavLink, useCCTM, useModel } from "@bcm-dev/bcms-vite";
import CustomDrawer from "components/custom-ui/CustomDrawer";
import CustomModal, { CustomModalContent } from "components/custom-ui/CustomModal";
import React from "react";


import "./styles.css";



/**
 * @function MenuModal
 * @return {React.Component}
 * @exported true
 * @description The main component for the Modal
 */
export default function MenuModal(props) {

      const {demos ,branding} = useModel();
            const xml =  useCCTM(),
                    menu = <CCTM nav-id={props.data} xml={xml} self={MenuModalContainer}>
                                <CCTM_nav component={MenuModalContainer}/>                            
                                <CCTM_route component={MenuModalElement}/>                  
                                <CCTM_link component={MenuModalElement}/> 
                                <CCTM_item component={MenuModalElement}/>   
                                <CCTM_items component={MenuModalContainer}/>                     
                                <CCTM_demo component={MenuModalElement} demos={demos}/> 
                                 <CCTM_subnav component={ModalSubMenu}/>              
                            </CCTM>;    
          return <>
     
          {menu}
          </>;
   
}
function ModalSubMenu(props){
    const {demos } = useModel();
    return <CCTM xml={props.currentNode} self={MenuModalWrapper} data={props.data}>            
                       <CCTM_subnav component={ModalSubMenu}  /> 
                        <CCTM_route component={MenuModalElement}/>                  
                        <CCTM_link component={MenuModalElement}/> 
                        <CCTM_item component={MenuModalElement}/>
                        <CCTM_items component={MenuModalContainer}/>                   
                        <CCTM_demo component={MenuModalElement} demos={demos}/>                       
                    </CCTM>;
}
function MenuModalContainer(props) {
    return (
       <>
        {props.children}
       </>
       
       
    )
}
function MobileMenuModalWrapper(props) {
    return (
        <CustomDrawer id={props.id} className="custom-mobile-menu">
        {props.children}
        </CustomDrawer>
    )
}

function MenuModalWrapper(props) {
    return (
       <CustomModal title={props.label}  id="MenuModal" dataPoint="MenuModal" className={"custom-modal "+(props["custom-class"]? props["custom-class"] :'')} >
        <CustomModalContent>
            {props.children}
        </CustomModalContent>
        </CustomModal>
    )
}
function MenuModalElement(props) {
   
    return (
        <div className={props["custom-class"]?props["custom-class"]:''}>
            <NavLink onClick={props.onClick?props.onClick:  ()=>{} } to={props.to} className="custom-modal-link">
        <span className="custom-modal-label">{props.label}</span>
       </NavLink>
        </div>
       
    )
}